import Vue from 'vue';
import VueRouter, { RouteConfig } from 'vue-router';
import HomeView from '../views/HomeView.vue';
import CreateAccount from '../views/Auth/CreateAccount.vue';
import CreatePassword from '../views/Auth/CreatePassword.vue';
import ResetPassword from '../views/Auth/ResetPassword.vue';
import Login from '../views/Auth/AppLogin.vue';
import InvalidLink from '../views/InvalidLink.vue';
import BankAccountSetup from '../views/BankAccountSetup/BankAccountSetup.vue';
import Error from '../views/Error.vue';
import Portal from '@/views/Portal.vue';
import AuthLayout from '@/components/Layout/AuthLayout.vue';
import { createAccountGuard, routeIfAuthenticated, requiresToken } from './guards';

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: '/',
    component: HomeView,
    redirect: { name: 'home' }
  },
  {
    path: '/auth',
    name: 'auth',
    component: AuthLayout,
    beforeEnter: routeIfAuthenticated,
    children: [
      {
        path: '/login',
        name: 'login',
        component: Login,
      },
      {
        path: '/create-account',
        name: 'create-account',
        component: CreateAccount,
        beforeEnter: createAccountGuard
      },
      {
        path: '/create-password',
        name: 'create-password',
        component: CreatePassword,
      },
    ]
  },
  {
    path: '/portal',
    component: Portal,
    children: [
      {
        path: '',
        name: 'home',
        component: HomeView,
      },
      {
        path: 'bank-account-setup',
        name: 'bank-account-setup',
        component: BankAccountSetup
      }
    ]
  },
  {
    path: '/reset-password',
    name: 'reset-password',
    component: ResetPassword,
    beforeEnter: requiresToken
  },
  {
    path: '/invalid',
    name: 'invalid',
    component: InvalidLink
  },
  {
    path: '/error',
    name: 'error',
    component: Error
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
});

export default router;
